import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Configuration {
  public apiHost: string;
  public authenticationUrl: string;

  constructor() {
    this.apiHost = environment.baseApiUrl;
  }
}
